/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
  If you need to add or edit existing variables, check out
  discord_common/js/packages/tokens/definitions, then run
  `clyde mana tokens generate`
*/
import type {ExperimentNames} from '../../types/tokens/generated/ExperimentNames';
import type {Density} from '../../layout/generated/generated-definitions';

type Modules = typeof Modules;
const Modules = {
  channels: {
    /* The size of the guild icons in the guilds bar */
    NAME_LINE_HEIGHT: {
      resolve({enabledExperiments, density}: {enabledExperiments: ExperimentNames[]; density: Density}) {
        if (enabledExperiments.length === 0) {
          return 20 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              switch (density) {
                case 'compact':
                  return 20 as const;
                case 'default':
                  return 24 as const;
                case 'cozy':
                  return 28 as const;

                default:
                  return 20 as const;
              }
          }
        }
        return 20 as const;
      },
    },
    /* The offset of the spine from the top of the channel list */
    SPINE_INVERTED_OFFSET_TOP: {
      resolve({enabledExperiments, density}: {enabledExperiments: ExperimentNames[]; density: Density}) {
        if (enabledExperiments.length === 0) {
          return 8 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              switch (density) {
                case 'compact':
                  return 2 as const;
                case 'default':
                  return 6 as const;
                case 'cozy':
                  return 9 as const;

                default:
                  return 8 as const;
              }
          }
        }
        return 8 as const;
      },
    },
    /* The offset of the spine from the left of the channel list */
    SPINE_OFFSET_LEFT: {
      resolve({enabledExperiments, density}: {enabledExperiments: ExperimentNames[]; density: Density}) {
        if (enabledExperiments.length === 0) {
          return 22 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              switch (density) {
                case 'compact':
                  return 20 as const;
                case 'default':
                  return 24 as const;
                case 'cozy':
                  return 28 as const;

                default:
                  return 22 as const;
              }
          }
        }
        return 22 as const;
      },
    },
  },
  chat: {
    /* Size of the avatar in pixels */
    AVATAR_SIZE: {
      resolve() {
        return 40 as const;
      },
    },
    /* Size of the icons in the input */
    INPUT_ICON_SIZE: {
      resolve({enabledExperiments}: {enabledExperiments: ExperimentNames[]}) {
        if (enabledExperiments.length === 0) {
          return 24 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              return 20 as const;
          }
        }
        return 24 as const;
      },
    },
    /* Line height for markup text */
    MARKUP_LINE_HEIGHT: {
      resolve() {
        return '1.375rem' as const;
      },
    },
    /* Width of the resize handle in pixels */
    RESIZE_HANDLE_WIDTH: {
      resolve() {
        return 8 as const;
      },
    },
  },
  form: {
    /* The default height for inputs */
    INPUT_HEIGHT: {
      resolve({enabledExperiments}: {enabledExperiments: ExperimentNames[]}) {
        if (enabledExperiments.length === 0) {
          return 48 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              return 44 as const;
          }
        }
        return 48 as const;
      },
    },
  },
  guildbar: {
    /* The size of the guild icons in the guilds bar */
    AVATAR_SIZE: {
      resolve({enabledExperiments, density}: {enabledExperiments: ExperimentNames[]; density: Density}) {
        if (enabledExperiments.length === 0) {
          return 48 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'refresh-fast-follow-avatars':
              switch (density) {
                case 'compact':
                  return 40 as const;
                case 'default':
                  return 44 as const;
                case 'cozy':
                  return 44 as const;

                default:
                  return 48 as const;
              }
            case 'visual-refresh':
              return 40 as const;
          }
        }
        return 48 as const;
      },
    },
    /* The size of folders in the guilds bar */
    FOLDER_SIZE: {
      resolve({enabledExperiments, density}: {enabledExperiments: ExperimentNames[]; density: Density}) {
        if (enabledExperiments.length === 0) {
          return 48 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'refresh-fast-follow-avatars':
              switch (density) {
                case 'compact':
                  return 48 as const;
                case 'default':
                  return 52 as const;
                case 'cozy':
                  return 52 as const;

                default:
                  return 48 as const;
              }
          }
        }
        return 48 as const;
      },
    },
  },
  modal: {
    /* The default horizontal spacing for modals */
    HORIZONTAL_PADDING: {
      resolve({enabledExperiments}: {enabledExperiments: ExperimentNames[]}) {
        if (enabledExperiments.length === 0) {
          return 16 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              return 24 as const;
          }
        }
        return 16 as const;
      },
    },
    /* The default vertical spacing for modals */
    VERTICAL_PADDING: {
      resolve() {
        return 16 as const;
      },
    },
    /* The width of a large modal */
    WIDTH_LARGE: {
      resolve() {
        return 800 as const;
      },
    },
    /* The width of a medium modal */
    WIDTH_MEDIUM: {
      resolve({enabledExperiments}: {enabledExperiments: ExperimentNames[]}) {
        if (enabledExperiments.length === 0) {
          return 600 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              return 602 as const;
          }
        }
        return 600 as const;
      },
    },
    /* The width of a small modal */
    WIDTH_SMALL: {
      resolve({enabledExperiments}: {enabledExperiments: ExperimentNames[]}) {
        if (enabledExperiments.length === 0) {
          return 440 as const;
        }

        for (const experiment of enabledExperiments) {
          switch (experiment) {
            case 'visual-refresh':
              return 442 as const;
          }
        }
        return 440 as const;
      },
    },
  },
} as const;
export const _private = {Modules};
